import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

// Panel-owned data - reset by resetPanelState when the citizen enters a different
// panel. Common-service data (commonObj / commonObjCommonConfig) is never reset.
const defaultIncentiveFarmerObj = () => ({
  hasDropdownLoaded: false,
  educationLevelList: [],
  cropList: [],
  circularList: [],
  instrumentList: [],
  supplierList: [],
  subsidyCircularTypeList: Custom.subsidyCircularTypeList,
  enlistedUniversityList: [],
  seasonSetupList: Custom.seasonList,
  projectList: [],
  agMaterialTypeList: [],
  macMachineTypeList: [],
  macBrandList: [],
  agMaterialList: []
})

// Full default state - restored by resetExternalState on admin/office login
const defaultState = () => ({
    incentiveFarmerObj: defaultIncentiveFarmerObj(),
    static: {
      perPage: 10,
      dateFormat: 'DD/MM/YYYY',
      fiscaleYear: 'YYYY-YYYY',
      timeFormat: 'h:m',
      loading: false,
      listReload: false,
      hasDropdownLoaded: false
    },
    commonObj: {
      hasDropdownLoaded: false,
      divisionList: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      officeTypeList: [],
      officeList: [],
      designationList: [],
      gradeList: [],
      fiscalYearList: []
    },
    commonObjCommonConfig: {
      hasDropdownLoaded: false,
      bankList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      branchList: [],
      wardList: []
    }
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPanelState (state) {
      state.incentiveFarmerObj = defaultIncentiveFarmerObj()
    },
    resetExternalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
